import React, { useState } from 'react';
import axios from 'axios';
import './../styles/Login.css';
import './../styles/GlobalStyles.css';
import * as globals from './../components/GlobalScripts.js';

const Login = () => {
    const [email, setEmail] = useState('');
    let path_api = localStorage.getItem('path_api');

    const handleSubmit = async (e) => {
        e.preventDefault();

        let inputs = document.querySelector('.card-login').querySelectorAll('input');
        let correo = inputs[0].value ? inputs[0].value.trim() : '';

        if (!correo) {
            globals.createAlert({ type: "error", msg_title: "Falta informacion", msg: "Ingresa tu correo", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            inputs[0].classList.add('requiered-outline');
        } else inputs[0].classList.remove('requiered-outline');

        if (document.querySelector('.card-login').querySelector('.requiered-outline')) {
            return;
        }

        globals.openViewCharge();
        await axios.post(`${path_api}/login.php`, {
            email,
            rute: globals.getRuteBackend()
        }).then(response => {
            if(response.data.mensaje == "success"){
                localStorage.setItem('session_id', response.data.session_id);
                localStorage.setItem('keylogin', response.data.keylogin);
                globals.createAlert({type: "success", msg_title: "Validado", msg: "Redirigiendo al proceso requerido", effect: "opacidad 2s, desplazamiento 2s", time_life: response.data.seconds_return*1000});
                
                window.setTimeout(function(){
                    window.location.href = response.data.url_return;
                }, response.data.seconds_return*1000);
            }else if(response.data.mensaje){
                globals.createAlert({type: "error", msg_title: "Error", msg: response.data.mensaje, effect: "opacidad 2s, desplazamiento 2s", time_life: 4000});
            }else{
                globals.createAlert({ type: "error", msg_title: "Error", msg: "Si persiste informe al soporte", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Credenciales incorrectas", msg: "El correo no esta registrado", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
        globals.closeViewCharge();
    };

    return (
        <>
            <div className="card-login">
                <div className="group-column">
                    <h3 className='no-margin'>Iniciar sesión</h3>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="group-column">
                        <label className="requiered-input">Correo</label>
                        <input type="email" name="email" className="input-primary" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ejemplo@correo.com" />
                    </div>

                    <div className="flex-row justify-end gap-20">
                        <button className="button-primary" type="submit">Continuar</button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default Login;